import React from 'react';
import BackgroundMusicContext from '../BackgroundMusicContext';

export default function BackgroundMusicProvider(props) {
  const { children } = props;
  return <BackgroundMusicContext.Provider>{children}</BackgroundMusicContext.Provider>;
}
